// Module
var code = "<translations-manager></translations-manager> ";
// Exports
module.exports = code;